import { AllegatoDtoTipoDocumentoEnum, PagamentoDto } from "@api/client";
import { fileUpload } from "common/_redux/file/actions";
import { paymentsGetPayments } from "common/_redux/payments/actions";
import { paymentsPaymentsSelector } from "common/_redux/payments/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import BftDropzone from "common/components/dropzone";
import { FilesUtils } from "common/file.utils";
import { IdTipoDocumenti, IdTipoDocumentiEstesi } from "constants/global";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { Formik } from "formik";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Topbar from "layout/components/topbar";
import { FileDocument } from "models/files";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import useReopenNavigate from "../hooks/reopenNavigate";

const title = "Pagamenti";
const subtitle = "Allega il frontespizio del documento.";

export interface ContrattoExt extends PagamentoDto {
	INT_ESTRATTO_CONTO?: FileDocument | undefined;
}

const documentiVisibili = ["INT_ESTRATTO_CONTO"];

const ReopenDocumentiPagamenti: React.FC = () => {
	const dispatch = useAppDispatch();
	const reopenNavigate = useReopenNavigate();

	const payments = useAppSelector(paymentsPaymentsSelector);

	const navBack = () => {
		reopenNavigate?.goBack();
	};

	const goNext = () => {
		reopenNavigate?.goNext();
	};

	const _handleSubmit = async (values: ContrattoExt) => {
		let _values = { ...values };

		let documents: (FileDocument | undefined)[] = [];

		documents.push(_values?.INT_ESTRATTO_CONTO);

		documents = documents?.filter((f) => f != undefined && f?.size > 0);

		delete _values?.INT_ESTRATTO_CONTO;

		dispatch(fileUpload(documents as FileDocument[]))
			.unwrap()
			.then((res) => {
				if (res || documents.length < 1) {
					goNext();
				}
			});
	};

	useEffect(() => {
		dispatch(paymentsGetPayments());
	}, []);

	return (
		<>
			<div className="d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Header />
					<Topbar />
					<div className="container-fluid body-section px-0">
						<section>
							<Row>
								<Col sm={12} lg={8}>
									<Formik
										initialValues={
											{
												reagioneSociale: payments?.reagioneSociale || "",
												partitaIva: payments?.partitaIva || undefined,
												codiceFiscale: payments?.codiceFiscale || undefined,
												iban: payments?.iban || "",
												nomeProponente: payments?.nomeProponente || "",
												cognomeProponente: payments?.cognomeProponente || "",
												codiceFiscaleProponente: payments?.codiceFiscaleProponente || "",
												tipologiaPagamento: payments?.tipologiaPagamento,
												idPagamento: payments?.idPagamento,
												INT_ESTRATTO_CONTO: FilesUtils.AllegatoDtoToFileDocument(
													payments?.elencoAllegati?.find(
														(f) => f.tipoDocumento == AllegatoDtoTipoDocumentoEnum.IntEstrattoConto
													)
												),
											} as ContrattoExt
										}
										onSubmit={_handleSubmit}
									>
										{({
											values,
											errors,
											touched,
											handleSubmit,
											setFieldValue,
											setFieldTouched,
										}) => {
											const handleFileChange = (name: string, file?: FileDocument | null) => {
												setFieldTouched(name);
												setFieldValue(name, file);
											};

											console.log(errors);

											return (
												<form onSubmit={handleSubmit}>
													<h2 className="mb-3 ms-3">{title}</h2>
													<span className="gray">{subtitle}</span>

													<BftAccordion
														title="Mandato di addebito diretto SDD e/o di accredito"
														subtitle="Autorizzazione di addebito in qualità di Debitore degli importi spettanti alla Società (Buffetti Finance S.p.A.) a fronte dei Servizi fruiti e/o di accredito delle transazioni incassate a mezzo POS."
														index={1}
														total={1}
														isActive={true}
													>
														<div className="px-1">
															{
																<div>
																	<div className="d-flex container d-flex justify-content-center">
																		<h6 style={{ fontSize: "18px" }}>
																			Frontespizio di Estratto Conto*
																		</h6>
																	</div>
																	<Col
																		md={6}
																		className="my-3 d-flex container d-flex justify-content-center flex-column"
																	>
																		<BftDropzone
																			label=""
																			idTipoDocumento={IdTipoDocumenti.INT_ESTRATTO_CONTO}
																			file={values.INT_ESTRATTO_CONTO}
																			trascinaDocumento={IdTipoDocumentiEstesi?.INT_ESTRATTO_CONTO}

																			onChange={(e) =>
																				handleFileChange(IdTipoDocumenti.INT_ESTRATTO_CONTO, e)
																			}
																			isInvalid={
																				!!(touched.INT_ESTRATTO_CONTO && errors.INT_ESTRATTO_CONTO)
																			}
																		/>
																	</Col>
																</div>
															}
														</div>
													</BftAccordion>

													<Row className="justify-content-between mx-1">
														<Col xs={1}>
															<BftButton
																className="btn-buffetti-secondary px-3"
																onClick={() => navBack()}
															>
																<i className="fas fa-arrow-left"></i>
															</BftButton>
														</Col>

														<Col xs={10} md={11}>
															<BftButton type="submit" className="btn-buffetti col-12">
																Vai allo step successivo
															</BftButton>
														</Col>
													</Row>
												</form>
											);
										}}
									</Formik>
								</Col>
								<Col sm={12} md={4} className="side-card">
									<DettaglioPianoCard />
								</Col>
							</Row>
						</section>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

export default ReopenDocumentiPagamenti;
